/**
 * Canonical product messaging for authenticated surfaces and /login.
 * Public marketing pages are intentionally excluded from this file.
 */

export const BRAND_MESSAGING = {
  login: {
    heading: 'Private beta workspace for litigation finance underwriting.',
    subheading:
      'Turn matter materials into a repeatable underwriting record before partner and committee review.',
    stats: [
      { value: 'Source-linked', label: 'Record' },
      { value: 'Human review', label: 'Analyst acceptance' },
      { value: 'IC artifacts', label: 'Committee packet' }
    ],
    trustBullets: [
      'Organize matter materials into a repeatable underwriting record',
      'Track open diligence, assumptions, and evidence links',
      'AI helps organize and draft; analysts own conclusions'
    ]
  },

  dashboard: {
    verdeScoreDescription:
      'Underwriting intelligence workspace for matter readiness, evidence support, blockers, and committee-ready artifacts.',
    workspaceDescription:
      'Underwriting operations support for matter materials, review pressure, research, and document intake.'
  },

  about: {
    overview:
      'VerdeKai is institutional underwriting infrastructure for litigation finance. It turns matter materials into a repeatable, source-linked record for partner and committee review. AI helps organize and draft; analysts own conclusions.',
    technology:
      'Built with React and Firebase. Structured VerdéScore workflows stay deterministic and reviewable without a provider. Optional local or cloud inference supports qualitative drafting. Core workflows are designed for transparency, auditability, and analyst speed.',
    security:
      'Data handling is explicit by mode: authenticated access, governed records, optional on-device analysis when policy requires it, and managed cloud inference when enabled.'
  }
};

export default BRAND_MESSAGING;
